/**
 * TODO - Look at creating a default options, which can be overwritten
 * by props.rehypeReactOptions?.components etc. if it exists.
 */

import { Remark, RemarkProps } from "@skv/react-remark";

export const ParseRemark = (props: RemarkProps) => {
  return (
    <div className="text-break mb-0">
      <Remark
        rehypeReactOptions={{
          components: {
            ul: ({ children, ...rest }) => (
              <ul
                {...rest}
                css={`
                  list-style-type: disc;
                  padding-left: 1.5rem;
                `}
              >
                {children}
              </ul>
            ),
          },
        }}
      >
        {props.children}
      </Remark>
    </div>
  );
};
